import React from 'react';
import ProfitAnalytics from './ProfitAnalytics';

const Profit: React.FC = () => {
  return (
    <div className="profit-page">
      <ProfitAnalytics />
    </div>
  );
};

export default Profit;